import React , { useEffect , useState , useRef } from 'react'

import Select from 'react-select';

import { ApiCallGet, ApiCallPost } from '../ApiCall/ApiCall';

import { useNavigate ,  useLocation } from "react-router-dom";

export default function Horarrios() {

  const [theOptions,setTheOptions] = useState([])
  const [isSelected,setIsSelected] = useState(false)
  const [campSelected,setCampainSelected] = useState("")

  const [maxsms,setMaxSms] = useState( 16 ) ;
  const [desde,setDesde] = useState( null ) ;
  const [hasta,setHasta] = useState( null ) ;

  const [elements,setElements] = useState([])

  const selectRef = useRef(null)
  const labelRef = useRef(null)

  const location = useLocation() ;
  const navigate = useNavigate() ;

  var options = [
 
  ]

  useEffect( () => {

    if ( location.state === null ){
      navigate( "/" )
      return ; 
    }

  

  } , [] )


  function onMaxSmsChange( e )
  {
    console.log( "onMaxSmsChange = " + e.target.value )
    setMaxSms( e.target.value )
  }


  function onSubmit(e)
  {
    e.preventDefault()

    console.log("onSubmit " + campSelected.value )


    var theMaxsms = document.getElementById("maxsms").value 


    console.log( "maxsms = " +  document.getElementById("maxsms").value )



    var obj = {
      campain : campSelected.value,
      maxsms : theMaxsms ,
      hora :  document.getElementById("hora").value + ":00",
      horafin :  document.getElementById("horafin").value + ":00",
      dTimeStamp : new Date()
    }

    options.push( { value : campSelected.value , label : campSelected.label } )

    //elements.push( obj )

    var arr = []

    arr.push( obj )

    

    

    setElements( [...elements, obj] )

    ApiCallPost('horario', obj)
    .then( (response) => {
      console.log( response )
      alert( response.mensaje )
    } )
    .catch( (error) => {
      console.log( error )
    } )




  }

  useEffect(()=>
  {
    console.log("elements = ", elements)
  } , [])
  

  function onchangeInput( e )
  {
    console.log( "OnChangeInput = " , e  )
  }

  
  function onSelectCampain(val){

    console.log( "Seleccionamos la campaña" )

    if ( isSelected === false ){
      //alert( "No hay campaña seleccionada" )

      //selectRef.current.disabled = true 

      //setIsSelected( false )

      console.log( "SELECTED =  " , val )

      

      setCampainSelected( val )

      var arr = []

      ApiCallGet('gethorarios/?campain=' + val.value )
      .then( (response) => {
        //console.log( "Nos esta llegando la respuesta")
        //console.log( response )
        for( var i = 0 ; i < response.length ; i++ ){
          arr.push({ maxsms : response[i].maxsms, desde : response[i].desde, hasta : response[i].hasta, hora : response[i].hora  , horafin : response[i].horafin  , id : response[i].id })
        }
        setElements( arr )
      } )
      .catch( (error) => {
        console.log( error )
      })


      alert( "Campaña seleccionada " + val.label )
      
    }




  }

  useEffect( () => {

    ApiCallGet('getcampains')
    .then( (response) => {
      //console.log( "Nos esta llegando la respuesta")
      //console.log( response )
      for( var i = 0 ; i < response.length ; i++ ){
        options.push({ value : response[i].id, label : response[i].name })
      }
      setTheOptions( options )
    } )
    .catch( (error) => {
      console.log( error )
    })


  } , [] )

  return (
    <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >

    < div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2 w-100'  id="page1" style={{margin : 'auto'}}>

          <div className='row'>
              <div className='col-sm-8'>
              
 
                <h5>Administrador de Horarios SMS</h5>
                
              </div>
          </div>
      

    <div className='row'>           

            <div className='col-4' >
              <Select ref={selectRef}  options={theOptions} 
                placeholder="Seleccione una campaña" onChange={onSelectCampain}/>  

            </div> 

            <div className='col-4'>
              <button type='button' className="btn btn-primary mt-1 button-3" >Selecciones Campaña</button> 
            </div>


            <div className='col-4'>
              <p ref={labelRef} >{campSelected.label}</p> 
            </div>

            <form onSubmit={(e)=>{onSubmit(e)}} className='row mt-5' style={{width: "100%"}}>

              <div className='row'>

              <div className='col-3'>
                  <label className="form-label m-0" htmlFor="maxsms">MaxSms</label>
                  <input type="number" className="form-control" id="maxsms" min={maxsms} 
                  value={maxsms} onChange={onMaxSmsChange} />
              </div>


              <div className='col-3'>
                  <label className="form-label m-0" htmlFor="hora">Hora Inicio</label>
                  <input type="time" className="form-control" id="hora"   />
                </div>

                <div className='col-3'>
                  <label className="form-label m-0" htmlFor="horafin">Hora Fin</label>
                  <input type="time" className="form-control" id="horafin"   />
                </div>  

              </div>

              <div className='row mt-1'>


                <div className='col-3'>
                  <button type="submit"  className="btn btn-primary mt-5 button-3"  >Agregar</button> 
                </div>


              </div>
            </form>

            <div className='row mt-5'>
              <div className='col-12'>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Num</th>
                      <th scope="col">MaxSms</th>
                      <th scope="col">HoraInicio</th>
                      <th scope="col">HoraFin</th>
                      <th scope="col">Eliminar</th>
                      <th scope="col">Editar</th>
                    </tr>
                  </thead>
                  <tbody>

                  {elements.map((value,index) => {
                      //return <input key={index} onChange={(val)=>{onchangeInput(val, index)}} /> 
                      return     <tr>
                      <th scope="row">{index+1}</th>
                      <td>{value.maxsms}</td>
                      <td>{value.hora}</td>
                      <td>{value.horafin}</td>
                      {/* <td>{value.desde}</td>
                      <td>{value.hasta}</td> */}
                      <td className='ps-0'><input key={index} onChange={(val)=>{onchangeInput(index)}}  type='checkbox'></input></td>
                      <td><input key={index} onChange={(val)=>{onchangeInput(index)}}  type='checkbox'></input></td>
                    </tr> ;
                  })}
                  </tbody>
                </table>
              </div>
            </div>

          

    </div>
    </div>
    </div>
  )
}
